import React from 'react';
import { Navigate } from 'react-router-dom';
import useProfileService from './hooks/useProfileService';
import { AppRoutes } from './routes';

interface PublicOnlyRouteProps {
    children: React.ReactElement;
    redirectTo?: string;
}

/**
 * Wrapper component for routes that should only be accessible when NOT authenticated.
 * If user is authenticated (has profile in localStorage), redirects to specified path.
 * Used for login and signup pages.
 */
const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({
    children,
    redirectTo = AppRoutes.TUTOR_PROFILE
}) => {

    const { getProfile } = useProfileService();
    const userProfile = getProfile();

    return userProfile ? <Navigate to={redirectTo} replace /> : children;
};

export default PublicOnlyRoute;
